/**
 * API Configuration
 * 
 * This file centralizes API configuration and provides utility functions
 * for making API calls with the correct base URL.
 */

// Get the API base URL from environment variable or use default
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://lbbackend.codingindia.co.in';

/**
 * Get the full API endpoint URL
 * @param {string} endpoint - The endpoint path (e.g., '/CreateRecord/')
 * @param {boolean} useCache - Whether to allow browser caching (defaults to true)
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint, useCache = true) => {
  // Ensure endpoint starts with /
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  let url = `${API_BASE_URL}${path}`;

  if (!useCache) {
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}_t=${new Date().getTime()}`;
  }
  
  return url;
};

/**
 * Common API endpoints
 */
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/Authentication/token/',
  REFRESH_TOKEN: '/token/refresh/',
  LOGOUT: '/logout/',

  // User Management
  CREATE_RECORD: '/CreateRecord/',
  UPDATE_RECORD: '/UpdateRecord/',
  DELETE_RECORD: (id) => `/DelRecord/${id}/`,
  GET_ALL_RECORDS: '/GetAllRecord/',
  GET_ALL_RECORD_MODELS: '/get-all-record-models/',
  GET_RECORD: (id) => `/record/${id}/`,

  // Permissions
  GET_USER_PERMISSIONS: '/Authentication/user_profile_permissions/',
  UPDATE_USER_PERMISSIONS: (userId) => `/Authentication/user_profile_permissions/${userId}/update/`,

  // Announcements
  ANNOUNCEMENTS_LIST: '/announcements/',
  CREATE_ANNOUNCEMENT: '/create_announcement/',
  EDIT_ANNOUNCEMENT: (id) => `/edit_announcement/${id}/`,
  DELETE_ANNOUNCEMENT: (id) => `/delete_announcement/${id}/`,

  // Team Leader
  CREATE_TEAM_LEADER: '/create_teamleader/',
  GET_TEAM_LEADERS: '/getTeamLeadersTableData/',

  // Docladder
  CREATE_TEAM_MEMBER: '/Docladder/create_Teammember_api/',
  GET_DOCLADDER_MEMBERS: '/Docladder/getDocladderTableData/',

  // AI Chat
  AI_CHAT_QUERY: '/AIChat/query/',
  AI_CHAT_SESSIONS: '/AIChat/sessions/',
  AI_CHAT_SESSION_DETAIL: (sessionId) => `/AIChat/sessions/${sessionId}/`,

  // Other endpoints can be added here as needed
};

export default {
  API_BASE_URL,
  getApiUrl,
  API_ENDPOINTS,
};

